/**
 * TODO: describe function
 * @author Kevin Parkinson
 * @param regions (any[])
*/
export const simplifyContentfulRegionsAny = (regions: any[]): string[] => regions.map((item) => (item && item.fields && item.fields.region ? item.fields.region : ''));
